import React from 'react';
import { Bowser } from '@factorin/util';
import { config } from '@factorin/container.macro';


const bowser = new Bowser();
const isNative = !bowser.ie;

/** @type {React.FC<{ url: string, className?: string }>} */
export const PdfContainer = ({ className, url }) => (
    <iframe
        className={className}
        title='pdf'
        src={isNative
            ? url
            : `${config.basePath || ''}${config.pathPrefix || ''}/pdfjs-dist/web/viewer.html?file=${url}`}
    />
);
